import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { AdditionalGroupResponse, AdditionalGroupResponseItem } from '@/types/service-response'

export class AdditionalGroup {
  public constructor (
    readonly id: number,
    readonly label: string,
    readonly groupCode: string,
    readonly date: string,
    readonly project: number | null,
    readonly children: AdditionalField[]
  ) {}

  public static createFromResponse (responseData: AdditionalGroupResponse): Array<AdditionalGroup> {
    let result: Array<AdditionalGroup> = []
    if (responseData) {
      result = responseData.map((item: AdditionalGroupResponseItem ) => {
        const fields: AdditionalField[] = AdditionalField.createFromResponse(item)
        return new AdditionalGroup(
          item.GroupID,
          item.GroupName,
          item.GroupCode,
          item.Date ? item.Date : '',
          item.Projekt ? item.Projekt : null,
          fields
        )
      })
    }
    return result
  }
}